<template>
  <div>
    <!-- 标题 -->
    <div class="rds-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.databaseId }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/relationalDatabaseServiceMonitor">{{
          $t("alarms.database.database")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="rds-top">
      <Row :gutter="16" v-show="isAWS">
        <Col span="7">
          <DatePicker
            confirm
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间区间"
            :options="dataOptions"
            style="width: 350px"
            v-model="timeRegion"
            @on-change="handleChangeTime"
            @on-ok="changeTimeType"
            @on-clear="handleClear"
          ></DatePicker>
        </Col>
        <Col span="5">
          <Select v-model="cycle" @on-change="changeCycle()">
            <Option
              v-for="item in cycleList"
              :value="item.value"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountTypeName == 'AWS'
          ? awsList
          : []"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import utils from "../../../../utils/utils.js";
export default {
  name: "RDS",
  data() {
    return {
      dataOptions: {
        disabledDate(value) {
          // 把当前时间的前 14天 后 14天之外的都禁用
          const startTime = new Date();
          const endTime = new Date();
          startTime.setDate(new Date().getDate() - 14);
          endTime.setDate(new Date().getDate() + 14);
          return !(value >= startTime && value <= endTime);
        }
      },
      startDate: "",
      endDate: "",
      timeRegion: [],
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // aws折线图
      awsList: [
        {
          id: "cpu",
          title: this.$t("alarms.database.line.CPUUtilizationPercent")
        },
        {
          id: "databaseConnections",
          title: this.$t(
            "alarms.database.line.NumberOfDatabaseConnectionsNumber"
          )
        },
        {
          id: "freeStorage",
          title: this.$t("alarms.database.line.AvailableStorageSpaceBytes")
        },
        {
          id: "availableMemory",
          title: this.$t("alarms.database.line.AvailableMemoryMB")
        },
        {
          id: "writeReadIOPS",
          title: this.$t("alarms.database.line.ReadAndWriteIOPSTimesSecond")
        },
        {
          id: "writeReadThroughput",
          title: this.$t("alarms.database.line.ReadAndWriteThroughputMBSec")
        }
      ],
      isAWS: false,
      isALY: false,
      isGCP: false,
      isAzureMySQL: false,
      isAzureSQLServer: false,
      timeType: 0,
      timeList: [],
      accountTypeName: "",
      accountName: "",
      product: "",
      // echarts实例
      chart: "",
      chartDatabaseConnections: "",
      chartCpucreditBalance: "",

      chartFreeStorage: "",
      chartAvailableMemory: "",
      chartWriteReadIOPS: "",
      chartWriteReadThroughput: "",

      cpuOption: {},
      databaseConnectionsOption: {},
      cpucreditBalanceOption: {},
      cpucreditUsageOption: {},
      ebsbyteBalanceOption: {},
      ebsiobalanceOption: {},
      networkReceiveThroughputOption: {},
      networkTransmitThroughputOption: {},
      readLatencyOption: {},
      writeLatencyOption: {},
      bufferCacheHitRatioOption: {},
      freeStorageOption: {},
      availableMemoryOption: {},
      writeReadIOPSOption: {},
      writeReadLatencyOption: {},
      networkReceiveTransmitThroughOption: {},
      queueDepthOption: {},
      binaryLogDiskUsageOption: {},
      writeReadThroughputOption: {}, //aws

      // 数组
      rdscpu: [],
      databaseConnections: [],
      cpucreditBalance: [],
      cpucreditUsage: [],
      ebsbyteBalance: [],
      ebsiobalance: [],
      networkReceiveThroughput: [],
      networkTransmitThroughput: [],
      readLatency: [],
      writeLatency: [],
      bufferCacheHitRatio: [],
      diskQueueDepth: [],
      rdsdiskMonitorNative: [],
      rdsramMonitorNative: [],
      rdsreadIOPS: [],
      rdswriteIOPS: [],
      readThroughput: [],
      writeThroughput: [],
      xaxisData: [],
      cycle: 300,
      cycleList: [
        {
          name: this.$t("alarms.common.fiveMinutes"),
          value: 5 * 60
        },
        {
          name: this.$t("alarms.common.fifteenMinutes"),
          value: 15 * 60
        },
        {
          name: this.$t("alarms.common.oneHour"),
          value: 1 * 60 * 60
        },
        {
          name: this.$t("alarms.common.sixHour"),
          value: 6 * 60 * 60
        },
        {
          name: this.$t("alarms.common.oneDay"),
          value: 24 * 60 * 60
        }
      ],
      rdscpuByAi: [],
      databaseConnectionsByAi: [],
      rdsdiskMonitorNativeByAi: [],
      rdsramMonitorNativeByAi: [],
      rdsreadIOPSByAi: [],
      rdswriteIOPSByAi: [],
      readThroughputByAi: [],
      writeThroughputByAi: []
    };
  },
  mounted: function() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function() {
        self.chart.resize();
        self.chartDatabaseConnections.resize();
        self.chartFreeStorage.resize();
        self.chartAvailableMemory.resize();
        self.chartWriteReadIOPS.resize();
        self.chartWriteReadThroughput.resize();
      });
      this.init();
    }
  },
  created() {
    if (this.$route.query.accountTypeName == "AWS") {
      this.isAWS = true;
      var myDate = new Date();
      let timestep = myDate.setHours(myDate.getHours(), 0, 0, 0); // 返回时间戳
      let timestep1 = myDate.setHours(myDate.getHours() + 1, 0, 0, 0); // 返回时间戳
      this.timeRegion[0] = this.startDate = utils.methods.formatDate(timestep);
      this.timeRegion[1] = this.endDate = utils.methods.formatDate(timestep1);
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function(item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          // AWS
          if (item.id == "cpu") {
            var optionFll = this.cpuOption;
          } else if (item.id == "databaseConnections") {
            var optionFll = this.databaseConnectionsOption;
          } else if (item.id == "cpucreditBalance") {
            var optionFll = this.cpucreditBalanceOption;
          } else if (item.id == "cpucreditUsage") {
            var optionFll = this.cpucreditUsageOption;
          } else if (item.id == "ebsbyteBalance") {
            var optionFll = this.ebsbyteBalanceOption;
          } else if (item.id == "ebsiobalance") {
            var optionFll = this.ebsiobalanceOption;
          } else if (item.id == "writeReadLatency") {
            var optionFll = this.writeReadLatencyOption;
          } else if (item.id == "networkReceiveTransmitThrough") {
            var optionFll = this.networkReceiveTransmitThroughOption;
          } else if (item.id == "bufferCacheHitRatio") {
            var optionFll = this.bufferCacheHitRatioOption;
          } else if (item.id == "freeStorage") {
            var optionFll = this.freeStorageOption;
          } else if (item.id == "availableMemory") {
            var optionFll = this.availableMemoryOption;
          } else if (item.id == "writeReadIOPS") {
            var optionFll = this.writeReadIOPSOption;
          } else if (item.id == "queueDepth") {
            var optionFll = this.queueDepthOption;
          } else if (item.id == "binaryLogDiskUsage") {
            var optionFll = this.binaryLogDiskUsageOption;
          } else if (item.id == "writeReadThroughput") {
            var optionFll = this.writeReadThroughputOption;
          }
          fullChart.setOption(optionFll);
          window.addEventListener("resize", function() {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function() {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then(res => {
          this.timeList = res.data;
        });
    },
    // 切换周期
    changeCycle: function() {
      this.init();
    },
    handleChangeTime(date) {
      if (!!date) {
        this.timeRegion = date;
        this.startDate = date[0];
        this.endDate = date[1];
      } else {
        this.timeRegion = [];
        this.startDate = "";
        this.endDate = "";
      }
    },
    // 切换时间
    changeTimeType: function() {
      this.init();
    },
    handleClear() {
      this.timeRegion = [];
      this.startDate = "";
      this.endDate = "";
      this.init();
    },
    /******************AWS 所有折线图********************************/
    init: function() {
      if (!this.startDate || !this.endDate) {
        this.$Message.error("请选择日期区间");
        return false;
      }
      this.cpusLine();
      this.chartDatabaseConnectionsLine();
      this.chartFreeStorageLine();
      this.chartAvailableMemoryLine();
      this.chartWriteReadIOPSLine();
      this.chartWriteReadThroughputLine();
    },
    // CPU 利用率 (百分比)
    cpusLine: function() {
      this.chart = this.$echarts.init(document.getElementById("cpu"));
      this.chart.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["CPUUtilization"]
        })
        .then(res => {
          this.chart.hideLoading();
          this.rdscpu = res.data.rdscpu;
          this.rdscpuByAi = res.data.rdscpuByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.cpuOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // CPU利用率
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.CPUUtilization"),
                this.$t("alarms.database.line.CPUUtilizationForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.database.line.CPUUtilization"),
                type: "line",
                data: this.rdscpu,
                itemStyle: {
                  normal: {
                    color: "#91c7ae",
                    lineStyle: {
                      color: "#91c7ae"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.CPUUtilizationForecast"),
                type: "line",
                data: this.rdscpuByAi,
                itemStyle: {
                  normal: {
                    color: "#00BFFF",
                    lineStyle: {
                      color: "#00BFFF"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chart.setOption(this.cpuOption, true);
        })
        .catch(err => {
          this.chart.hideLoading();
        });
    },
    // 数据库连接数 (数量)
    chartDatabaseConnectionsLine: function() {
      this.chartDatabaseConnections = this.$echarts.init(
        document.getElementById("databaseConnections")
      );
      this.chartDatabaseConnections.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["DatabaseConnections"]
        })
        .then(res => {
          this.chartDatabaseConnections.hideLoading();
          this.databaseConnections = res.data.databaseConnections;
          this.databaseConnectionsByAi = res.data.databaseConnectionsByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.databaseConnectionsOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 数据库连接数
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.NumberOfDatabaseConnections"),
                this.$t(
                  "alarms.database.line.NumberOfDatabaseConnectionsNumberForecast"
                )
              ]
            },
            series: [
              {
                name: this.$t(
                  "alarms.database.line.NumberOfDatabaseConnections"
                ),
                type: "line",
                data: this.databaseConnections,
                itemStyle: {
                  normal: {
                    color: "#c23531",
                    lineStyle: {
                      color: "#c23531"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.database.line.NumberOfDatabaseConnectionsNumberForecast"
                ),
                type: "line",
                data: this.databaseConnectionsByAi,
                itemStyle: {
                  normal: {
                    color: "#696969",
                    lineStyle: {
                      color: "#696969"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartDatabaseConnections.setOption(
            this.databaseConnectionsOption,
            true
          );
        })
        .catch(err => {
          this.chartDatabaseConnections.hideLoading();
        });
    },
    // 可用存储空间 (字节)
    chartFreeStorageLine: function() {
      this.chartFreeStorage = this.$echarts.init(
        document.getElementById("freeStorage")
      );
      this.chartFreeStorage.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["FreeStorageSpace"]
        })
        .then(res => {
          this.chartFreeStorage.hideLoading();
          this.rdsdiskMonitorNative = res.data.rdsdiskMonitorNative;
          this.rdsdiskMonitorNativeByAi = res.data.rdsdiskMonitorNativeByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.freeStorageOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 可用存储空间
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.AvailableStorageSpace"),
                this.$t(
                  "alarms.database.line.AvailableStorageSpaceBytesForecast"
                )
              ]
            },
            series: [
              {
                name: this.$t("alarms.database.line.AvailableStorageSpace"),
                type: "line",
                data: this.rdsdiskMonitorNative,
                itemStyle: {
                  normal: {
                    color: "#61a0a8",
                    lineStyle: {
                      color: "#61a0a8"
                    }
                  }
                }
              },
              {
                name: this.$t(
                  "alarms.database.line.AvailableStorageSpaceBytesForecast"
                ),
                type: "line",
                data: this.rdsdiskMonitorNativeByAi,
                itemStyle: {
                  normal: {
                    color: "	#FF00FF",
                    lineStyle: {
                      color: "	#FF00FF"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartFreeStorage.setOption(this.freeStorageOption, true);
        })
        .catch(err => {
          this.chartFreeStorage.hideLoading();
        });
    },
    // 可用内存 (MB)
    chartAvailableMemoryLine: function() {
      this.chartAvailableMemory = this.$echarts.init(
        document.getElementById("availableMemory")
      );
      this.chartAvailableMemory.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["FreeableMemory"]
        })
        .then(res => {
          this.chartAvailableMemory.hideLoading();
          this.rdsramMonitorNative = res.data.rdsramMonitorNative;
          this.rdsramMonitorNativeByAi = res.data.rdsramMonitorNativeByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.availableMemoryOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 可用内存
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.AvailableMemory"),
                this.$t("alarms.database.line.AvailableMemoryForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.database.line.AvailableMemory"),
                type: "line",
                data: this.rdsramMonitorNative,
                itemStyle: {
                  normal: {
                    color: "#ccc",
                    lineStyle: {
                      color: "#ccc"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.AvailableMemoryForecast"),
                type: "line",
                data: this.rdsramMonitorNativeByAi,
                itemStyle: {
                  normal: {
                    color: "#228B22",
                    lineStyle: {
                      color: "#228B22"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartAvailableMemory.setOption(this.availableMemoryOption, true);
        })
        .catch(err => {
          this.chartAvailableMemory.hideLoading();
        });
    },
    // 读写IOPS (次数/秒)
    chartWriteReadIOPSLine: function() {
      this.chartWriteReadIOPS = this.$echarts.init(
        document.getElementById("writeReadIOPS")
      );
      this.chartWriteReadIOPS.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["ReadIOPS", "WriteIOPS"]
        })
        .then(res => {
          this.chartWriteReadIOPS.hideLoading();
          this.rdsreadIOPS = res.data.rdsreadIOPS;
          this.rdswriteIOPS = res.data.rdswriteIOPS;
          this.rdsreadIOPSByAi = res.data.rdsreadIOPSByAi;
          this.rdswriteIOPSByAi = res.data.rdswriteIOPSByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.writeReadIOPSOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 读IOPS写IOPS
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.ReadIOPS"),
                this.$t("alarms.database.line.WriteIOPS"),
                this.$t("alarms.database.line.ReadIOPSForecast"),
                this.$t("alarms.database.line.WriteIOPSForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.database.line.ReadIOPS"),
                type: "line",
                data: this.rdsreadIOPS,
                itemStyle: {
                  normal: {
                    color: "#803500",
                    lineStyle: {
                      color: "#803500"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.WriteIOPS"),
                type: "line",
                data: this.rdswriteIOPS,
                itemStyle: {
                  normal: {
                    color: "#FF9B40",
                    lineStyle: {
                      color: "#FF9B40"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.ReadIOPSForecast"),
                type: "line",
                data: this.rdsreadIOPSByAi,
                itemStyle: {
                  normal: {
                    color: "	#9400D3",
                    lineStyle: {
                      color: "	#9400D3"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.WriteIOPSForecast"),
                type: "line",
                data: this.rdswriteIOPSByAi,
                itemStyle: {
                  normal: {
                    color: "#1E90FF",
                    lineStyle: {
                      color: "#1E90FF"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartWriteReadIOPS.setOption(this.writeReadIOPSOption, true);
        })
        .catch(err => {
          this.chartWriteReadIOPS.hideLoading();
        });
    },
    // 读写吞吐量 (MB/秒)
    chartWriteReadThroughputLine: function() {
      this.chartWriteReadThroughput = this.$echarts.init(
        document.getElementById("writeReadThroughput")
      );
      this.chartWriteReadThroughput.showLoading({
        text: "loading",
        color: "#ccc",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0
      });
      this.$api.cloudWatch
        .queryCheckAiIndex({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          period: this.cycle,
          monitorModule: 1,
          instanceId: this.$route.query.instanceId,
          region: this.$route.query.region,
          startTime: this.startDate,
          endTime: this.endDate,
          metricNames: ["ReadThroughput", "WriteThroughput"]
        })
        .then(res => {
          this.chartWriteReadThroughput.hideLoading();
          this.readThroughput = res.data.readThroughput;
          this.writeThroughput = res.data.writeThroughput;
          this.readThroughputByAi = res.data.readThroughputByAi;
          this.writeThroughputByAi = res.data.writeThroughputByAi;
          this.xaxisData = res.data.xaxisData;
          if (this.xaxisData[0] == null) {
            this.xaxisData = [];
          }
          this.writeReadThroughputOption = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                label: {
                  backgroundColor: "#6a7985"
                }
              }
            },
            // 读吞吐量 写吞吐量
            legend: {
              type: "scroll",
              // x: "right",
              // y: "10px",
              top: 10,
              right: 10,
              data: [
                this.$t("alarms.database.line.ReadThroughput"),
                this.$t("alarms.database.line.WriteThroughput"),
                this.$t("alarms.database.line.ReadThroughputForecast"),
                this.$t("alarms.database.line.WriteThroughputForecast")
              ]
            },
            series: [
              {
                name: this.$t("alarms.database.line.ReadThroughput"),
                type: "line",
                data: this.readThroughput,
                itemStyle: {
                  normal: {
                    color: "#a0a7e6",
                    lineStyle: {
                      color: "#a0a7e6"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.WriteThroughput"),
                type: "line",
                data: this.writeThroughput,
                itemStyle: {
                  normal: {
                    color: "#f58db2",
                    lineStyle: {
                      color: "#f58db2"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.ReadThroughputForecast"),
                type: "line",
                data: this.readThroughputByAi,
                itemStyle: {
                  normal: {
                    color: "#6495ED",
                    lineStyle: {
                      color: "#6495ED"
                    }
                  }
                }
              },
              {
                name: this.$t("alarms.database.line.WriteThroughputForecast"),
                type: "line",
                data: this.writeThroughputByAi,
                itemStyle: {
                  normal: {
                    color: "#DC143C",
                    lineStyle: {
                      color: "#DC143C"
                    }
                  }
                }
              }
            ],
            grid: {
              top: "20%",
              left: "3%",
              bottom: "3%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                data: this.xaxisData.map(function(str) {
                  return str.replace(" ", "\n");
                })
              }
            ],
            yAxis: [
              {
                splitNumber: 4,
                type: "value"
              }
            ]
          };
          this.chartWriteReadThroughput.setOption(
            this.writeReadThroughputOption,
            true
          );
        })
        .catch(err => {
          this.chartWriteReadThroughput.hideLoading();
        });
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function() {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.databaseId = this.$route.query.databaseId;
      this.region = this.$route.query.region;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.engine = this.$route.query.engine;
      this.$router.push({
        path: "/monitor/relationalDatabaseServiceDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          databaseId: this.databaseId,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
          name: this.name,
          engine: this.engine
        }
      });
    }
  }
};
</script>

<style scoped>
.rds-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.rds-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/rds_dashboard/RDSForecast.vue